var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#0E7162",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 995 l0 -995 990 0 990 0 0 995 0 995 -990 0 -990 0 0 -995z m755 453 c11 -13 35 -36 52 -52 l32 -28 51 51 51 51 104 0 c58 0 105 -3 105 -8 0 -4 -70 -77 -155 -162 l-155 -155 -163 163 -162 162 110 0 c101 0 111 -2 130 -22z m705 -33 l0 -54 -104 -104 -104 -104 104 -104 104 -104 0 -102 c0 -57 -3 -103 -7 -103 -4 0 -62 55 -129 123 -67 67 -135 135 -152 151 l-30 28 -257 -256 -257 -256 -54 0 -54 0 0 54 0 54 104 104 103 105 -103 104 -104 104 0 102 c0 57 3 103 7 103 4 0 62 -55 129 -122 67 -68 135 -136 152 -152 l30 -28 257 256 257 256 54 0 54 0 0 -55z m-107 -883 c-100 -3 -108 -1 -128 20 -11 13 -35 36 -52 52 l-32 28 -51 -51 -51 -51 -104 0 c-58 0 -105 2 -105 5 0 2 70 75 157 161 l156 155 159 -158 158 -158 -107 -3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiced);
export default __webpack_public_path__ + "static/media/invoiced.78d078e4d4810b684ca1588f54f13eb3.svg";
export { ForwardRef as ReactComponent };